import { useEffect, useRef } from "react";
import { latestBeatIndex } from "../state/markers";
import type { ReplayPayload } from "../types";

export interface StoryViewProps {
  replay: ReplayPayload;
  tick: number;
  onSeek: (tick: number) => void;
}

export function StoryView({ replay, tick, onSeek }: StoryViewProps) {
  const current = latestBeatIndex(replay.beats, tick);
  const currentRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    currentRef.current?.scrollIntoView({ block: "nearest" });
  }, [current]);
  return (
    <div className="view">
      <div className="story-list">
        {replay.beats.length === 0 && (
          <div className="pane-empty">no story beats — a quiet run</div>
        )}
        {replay.beats.map((beat, index) => {
          const status =
            current !== null && index === current
              ? "current"
              : beat.tick <= tick
                ? "passed"
                : "";
          return (
            <button
              key={index}
              type="button"
              className={`story-beat ${status}`}
              onClick={() => onSeek(beat.tick)}
              title="jump the replay to this beat"
              ref={current !== null && index === current ? currentRef : null}
            >
              <span className="story-tick">tick {beat.tick}</span>
              <span>{beat.text}.</span>
            </button>
          );
        })}
        {replay.closing && <div className="story-closing">{replay.closing}.</div>}
      </div>
    </div>
  );
}
